import events from 'events'

export default class BackButtonHandler extends events.EventEmitter {

  /**
   * Setup back button handling
   * should be called once
   */
  start() {
    this.fixDepth();
    window.addEventListener('popstate', this.popStateHandler.bind(this))
  }

  /**
   * Make sure we have always 2 pages in history stack
   */
  fixDepth() {
    if ((history.state?.depth ?? null) === null) {
      history.replaceState({depth: 0}, 'App Start');
    }
    if (history.state?.depth == 0) {
      history.pushState({depth: 1}, 'App');
    }
  }

  back() {
    this.emit('back')
  }

  /**
   * Handles back button
   */
  popStateHandler(event: PopStateEvent) {
    this.back();
    this.fixDepth();
  }

  /**
   * save stack to history so we can restore on page reload
   */
  updateHistory(state={}) {
    history.replaceState({
      ...state,
      depth: history.state?.depth,
    }, 'App Start');
  }
}